import React from 'react'
import Logo from '../../../../assets/Logo.png'
import { getProfilePhoto } from '../../../../helpers/image'

import './style.scss'

const InviteHeader = ({ userImage, userName }) => (
  <div className='header'>
    <img className='header_logo' src={Logo} alt='logo-mellro' />
    <img className='header_image' src={getProfilePhoto(userImage, userName)} alt='header' />

    <div className='header_name'>{userName}</div>
    <div className='header_invite'>Convidou você</div>
    <div className='header_context'>Você foi convidado pra fazer parte de uma negociação</div>
  </div>
)

// TODO: use ts
// InviteHeader.propTypes = {
//   userImage: PropTypes.string,
//   userName: PropTypes.string,
// }

export default InviteHeader
